import React, { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { MediumCenteredContainer } from '@eika/engine-view';
import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import { StringKeyValue } from '../actions/types';
import { AppState } from '../reducers';
import { ContextReducer } from '../reducers/context';
import { ErrorReducer } from '../reducers/error';
import AppErrors from './AppErrors';
import GlobalLoader from './GlobalLoader';

interface Props {
    context: ContextReducer;
    text: StringKeyValue;
    error: ErrorReducer;
    children: ReactNode;
}

class App extends Component<Props> {
    render() {
        /* Shows the missing config keys in Sitecore when in DEV */
        const appErrorMessages = (appErrors: ContextReducer['appErrors']) => {
            const isDevelop = process.env.NODE_ENV !== 'production';
            const errors = appErrors.map((appError) => (
                <p key={uuid()}>
                    <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={appError} />
                </p>
            ));
            return isDevelop && appErrors.length ? (
                <div className="missing-keys">
                    <MediumCenteredContainer>{errors}</MediumCenteredContainer>
                </div>
            ) : (
                <></>
            );
        };

        const { text, context, error, children } = this.props;
        const { appErrors } = context;
        return error.errorMessage ? (
            <AppErrors text={text} error={error} />
        ) : (
            <GlobalLoader>
                {children}
                {appErrorMessages(appErrors)}
            </GlobalLoader>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    context: state.context,
    error: state.error,
});

export default connect(mapStateToProps)(App);
